import {useParams, useLocation} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import {downloadBlob} from "@feature/commons/lib/utils";
import moment from "moment";
import {FormattedMessage} from "react-intl";
import CountryContext from "./CountryContext";

const ProductDocumentsDownloader = () => {

  // context
  const {country} = useContext(CountryContext);

  // hooks
  const countryApiRequest = useCountryAxiosInstance(country.code) as any;
  const {type, pid} = useParams<{type: string, pid: string}>();
  const locationQuery = new URLSearchParams(useLocation().search);

  // state
  const [status, setStatus]
    = useState<"PENDING" | "COMPLETE" | "ERROR">("PENDING");

  // validations
  if (!pid || !isFinite(Number(pid))) {
    throw new Error("Product ID is required and must be a number");
  }
  if (!["standard", "kcolor"].includes(type || "")) {
    throw new Error("Type is required and must be either 'standard' or 'kcolor'");
  }

  useEffect(() => {
    // On page load, fetch document URLs from the backend, generate the ZIP file containing the documents, and trigger
    // the download.
    countryApiRequest.get(`/products/${type}/${pid}/documents`, {publicRequest: true, responseType: "blob"})
      .then((b: Blob) => {
        downloadBlob(b, `${moment().format("YYYYMMDDHHmmss")}_product_${pid}_documents.zip`);
        setStatus("COMPLETE");
        if (!!locationQuery.get("autoclose"))
          window.close();
      })
      .catch(() => setStatus("ERROR"));
  }, [pid]);

  return (
    <div className="p-4">
      {status === "PENDING" && <FormattedMessage id="preparing_download" defaultMessage="File in preparazione, attendere..." />}
      {status === "COMPLETE" && <FormattedMessage id="download_ready" defaultMessage="Download pronto!" />}
      {status === "ERROR" && (
        <p className="text-red-700">
          <FormattedMessage id="download_error" defaultMessage="Si è verificato un errore durante il download. Si prega di riprovare più tardi." />
        </p>
      )}
    </div>
  )
};

export default ProductDocumentsDownloader;
